// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"n_by","stickyArticleHeaderContainer":"n_bz","stickyArticleHeaderButton":"n_bB","text_left":"n_bC","progressContainer":"n_bD","progressBar":"n_bF"};